import { reactive, readonly } from "vue";

export default variant => {
    const state = reactive({
        variant: variant,
        options: []
    });

    const selected = (name, value) => {
        return variant.selectedOptions.some(opt => opt.name == name && opt.value == value);
    };

    const optionMap = [];
    variant.product.variants.forEach(variant => {
       variant.selectedOptions.forEach(selectedOption => {
           const existing = optionMap.find(o => o.name === selectedOption.name);
           if(existing) {
               existing.values = [...existing.values, {name: selectedOption.name, text: selectedOption.value, selected: selected(selectedOption.name, selectedOption.value)}];
           } else {
               optionMap.push({name: selectedOption.name, values: [{name: selectedOption.name, text: selectedOption.value, selected: selected(selectedOption.name, selectedOption.value)}]});
           }
       })
    });

    state.options = optionMap;

    const select = opt => {
        let variants = state.variant.product.variants;

        state.options.forEach(g => {
            let value = g.values.find(v => v.selected);

            if (g.name == opt.name) {
                if (value)
                    value.selected = false;

                value = g.values.find(v => v.text == opt.text);
                value.selected = true;
            }

            variants = variants.filter(v => {
                var opt2 = v.selectedOptions.find(o => o.name == g.name);

                return (opt2.value == value.text);
            });
        });

        state.variant = variants[0];
    };

    return reactive({
        select,
        state: readonly(state),
    });
};
